import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Space, Empty, Input, message } from 'antd';
import styles from '@/common/Layout/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import {
  ArrowDownOutlined,
  DeleteOutlined,
  PlusCircleOutlined
} from '@ant-design/icons';
import Layout from '@/common/Layout';
import CustomTable from '@/common/Content/CustomTable';
import { useDispatch } from 'react-redux';
import {
  createNewBin,
  createNewArea,
  getAllBinList,
  generateBin,
  getAllEquipmentsList,
  generateEqp,
  getAllAreaList,
  generateArea
} from '../../redux/slice';
import { useLocation } from 'react-router-dom';
import { getLoggedInUser } from 'utilities/helpers';

const { Search } = Input;
const generateLable = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  // const [data, setData] = useState([]);
  // const [bin, setBin] = useState('');
  const [page, setPage] = useState(1);
  const [binList, setBinList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [equipmentsList, setEquipmentsList] = useState([]);
  const [bins, setbins] = useState([{ bin_number: '' }]);
  const [areas, setAreas] = useState([{ area_name: '', area_id: '' }]);
  const [pagination, setPagination] = useState('');
  const [search, setSearch] = useState('');

  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const { user } = getLoggedInUser();

  useEffect(() => {
    searchParams.get('type') === 'Equipment'
      ? handleGetAllEquipmentsList()
      : handleGetAllbinList();
  }, [page, search]);

  const handleGetAllbinList = () => {
    if (
      user?.role === 'prod_ebmr' &&
      searchParams.get('type') !== 'prod_label'
    ) {
      const payload = { search, page: page };
      dispatch(getAllAreaList(payload)).then(function (response) {
        if (response?.payload?.success) {
          setAreaList(response?.payload?.data);
          setPagination(response?.payload?.pagination);
        }
      });
    } else {
      const payload = { search, page: page };
      dispatch(getAllBinList(payload)).then(function (response) {
        if (response?.payload?.success) {
          setBinList(response?.payload?.data);
          setPagination(response?.payload?.pagination);
        }
      });
    }
  };

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleGetAllEquipmentsList = () => {
    const payload = { search, page: page };
    dispatch(getAllEquipmentsList(payload)).then(function (response) {
      if (response?.payload?.success) {
        setEquipmentsList(response?.payload?.data);
        setPagination(response?.payload?.pagination);
      }
    });
  };

  const handleGenerate = (bin) => {
    const payload = { bin_number: bin };
    dispatch(generateBin(payload)).then(function (response) {
      if (response?.payload?.success) {
        handleGetAllbinList();
      }
    });
  };

  const handleGenerateArea = (areaId) => {
    const payload = { area_id: areaId };
    dispatch(generateArea(payload)).then(function (response) {
      if (response?.payload?.success) {
        handleGetAllbinList();
      }
    });
  };
  const handleGenerateEqp = (bin) => {
    const payload = { id: bin };
    dispatch(generateEqp(payload)).then(function (response) {
      if (response?.payload?.success) {
        handleGetAllEquipmentsList();
      }
    });
  };

  const onFinish = (values) => {
    if (
      user?.role === 'prod_ebmr' &&
      searchParams.get('type') !== 'prod_label'
    ) {
      if (areas[0]?.area_name !== '' && areas[0]?.area_id !== '') {
        values['area_name_list'] = areas;
        dispatch(createNewArea(values)).then(function (response) {
          if (response?.payload?.success) {
            // setTimeout(() => {
            console.log(response?.payload?.data);
            message.success(response?.payload?.message);
            setAreas([{ area_name: '', area_id: '' }]);
            handleGetAllbinList();
            // }, 2000);
          }
        });
      } else {
        message.error('Please enter Area name and Area ID');
      }
    } else {
      values['bin_no'] = bins;
      dispatch(createNewBin(values)).then(function (response) {
        if (response?.payload?.success) {
          // setTimeout(() => {
          console.log(response?.payload?.data);
          message.success(response?.payload?.message);
          setbins([{ bin_number: '' }]);
          handleGetAllbinList();
          // }, 2000);
        }
      });
    }
  };
  const columns = [
    {
      title:
        searchParams.get('type') === 'Equipment'
          ? 'Equipment #'
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? 'Area Name'
          : 'Bin Number',
      dataIndex:
        searchParams.get('type') === 'Equipment'
          ? 'equipment_id'
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? 'area_name'
          : 'bin_number',
      key:
        searchParams.get('type') === 'Equipment'
          ? 'equipment_id'
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? 'area_name'
          : 'bin_number',
      width: '150px',
      ellipsis: true,
      sorter: (a, b) =>
        searchParams.get('type') === 'Equipment'
          ? a?.equipment_id?.localeCompare(b?.equipment_id)
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? a?.area_name?.localeCompare(b?.area_name)
          : a?.bin_number?.localeCompare(b?.bin_number),
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Generate label',
      dataIndex: 'bin_number',
      key: 'bin_number',
      width: '150px',
      ellipsis: true,
      sorter: (a, b) => a?.number?.localeCompare(b?.number),
      render: (text, record) => {
        return (
          <CustomButton
            type="primary"
            ghost
            onClick={() =>
              searchParams.get('type') === 'Equipment'
                ? handleGenerateEqp(record?.id)
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? handleGenerateArea(record?.area_id)
                : handleGenerate(text)
            }
            disabled={
              searchParams.get('type') === 'Equipment'
                ? record?.eqp_label
                  ? true
                  : false
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? record?.is_qrgenerated
                  ? true
                  : false
                : record?.bin_label
                ? true
                : false
            }
          >
            Generate Label
          </CustomButton>
        );
      },
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Download',
      dataIndex: 'bin_label',
      key: 'bin_label',
      width: '150px',
      ellipsis: true,
      sorter: (a, b) => a?.number?.localeCompare(b?.number),
      render: (text, record) => {
        return (
          <CustomButton
            type="primary"
            ghost
            onClick={() =>
              searchParams.get('type') === 'Equipment'
                ? handleGenerateEqp(record?.id)
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? handleGenerateArea(record?.area_id)
                : handleGenerate(text)
            }
            disabled={
              searchParams.get('type') === 'Equipment'
                ? record?.eqp_label
                  ? false
                  : true
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? !record?.is_qrgenerated
                  ? true
                  : false
                : record?.bin_label
                ? false
                : true
            }
          >
            <a
              href={
                searchParams.get('type') === 'Equipment'
                  ? `${process.env.REACT_APP_STORAGE_URL}${record?.eqp_label
                      ?.split('/')
                      ?.pop()}`
                  : user?.role === 'prod_ebmr' &&
                    searchParams.get('type') !== 'prod_label'
                  ? `${process.env.REACT_APP_STORAGE_URL}${record?.doc_url
                      ?.split('/')
                      ?.pop()}`
                  : `${process.env.REACT_APP_STORAGE_URL}${text
                      ?.split('/')
                      ?.pop()}`
              }
            >
              <ArrowDownOutlined /> Download
            </a>
          </CustomButton>
        );
      },
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    }
  ];

  const Areacolumns = [
    {
      title:
        searchParams.get('type') === 'Equipment'
          ? 'Equipment #'
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? 'Area Name'
          : 'Bin Number',
      dataIndex:
        searchParams.get('type') === 'Equipment'
          ? 'equipment_id'
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? 'area_name'
          : 'bin_number',
      key:
        searchParams.get('type') === 'Equipment'
          ? 'equipment_id'
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? 'area_name'
          : 'bin_number',
      width: '150px',
      ellipsis: true,
      sorter: (a, b) =>
        searchParams.get('type') === 'Equipment'
          ? a?.equipment_id?.localeCompare(b?.equipment_id)
          : user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
          ? a?.area_name?.localeCompare(b?.area_name)
          : a?.bin_number?.localeCompare(b?.bin_number),
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Area ID',
      dataIndex: 'area_id',
      key: 'area_id',
      width: '150px',
      ellipsis: true,
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Generate label',
      dataIndex: 'bin_number',
      key: 'bin_number',
      width: '150px',
      ellipsis: true,
      sorter: (a, b) => a?.number?.localeCompare(b?.number),
      render: (text, record) => {
        return (
          <CustomButton
            type="primary"
            ghost
            onClick={() =>
              searchParams.get('type') === 'Equipment'
                ? handleGenerateEqp(record?.id)
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? handleGenerateArea(record?.area_id)
                : handleGenerate(text)
            }
            disabled={
              searchParams.get('type') === 'Equipment'
                ? record?.eqp_label
                  ? true
                  : false
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? record?.is_qrgenerated
                  ? true
                  : false
                : record?.bin_label
                ? true
                : false
            }
          >
            Generate Label
          </CustomButton>
        );
      },
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    },
    {
      title: 'Download',
      dataIndex: 'bin_label',
      key: 'bin_label',
      width: '150px',
      ellipsis: true,
      sorter: (a, b) => a?.number?.localeCompare(b?.number),
      render: (text, record) => {
        return (
          <CustomButton
            type="primary"
            ghost
            onClick={() =>
              searchParams.get('type') === 'Equipment'
                ? handleGenerateEqp(record?.id)
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? handleGenerateArea(record?.area_id)
                : handleGenerate(text)
            }
            disabled={
              searchParams.get('type') === 'Equipment'
                ? record?.eqp_label
                  ? false
                  : true
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? !record?.is_qrgenerated
                  ? true
                  : false
                : record?.bin_label
                ? false
                : true
            }
          >
            <a
              href={
                searchParams.get('type') === 'Equipment'
                  ? `${process.env.REACT_APP_STORAGE_URL}${record?.eqp_label
                      ?.split('/')
                      ?.pop()}`
                  : user?.role === 'prod_ebmr' &&
                    searchParams.get('type') !== 'prod_label'
                  ? `${process.env.REACT_APP_STORAGE_URL}${record?.doc_url
                      ?.split('/')
                      ?.pop()}`
                  : `${process.env.REACT_APP_STORAGE_URL}${text
                      ?.split('/')
                      ?.pop()}`
              }
            >
              <ArrowDownOutlined /> Download
            </a>
          </CustomButton>
        );
      },
      responsive: ['xl', 'xs', 'sm', 'xxl', 'md']
    }
  ];
  let locale = {
    emptyText: (
      <span>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<span>There are no containers in this bin</span>}
        />
      </span>
    )
  };

  const hanldeAddbin = (e, index, type) => {
    if (
      user?.role === 'prod_ebmr' &&
      searchParams.get('type') !== 'prod_label'
    ) {
      const list = [...areas];
      type === 'area_name'
        ? (list[index].area_name = e.target.value)
        : (list[index].area_id = e.target.value);
      setAreas(list);
    } else {
      const list = [...bins];
      list[index].bin_number = e.target.value;
      setbins(list);
      console.log('aaa');
    }
  };

  const hanldeAddbinposition = () => {
    user?.role === 'prod_ebmr' && searchParams.get('type') !== 'prod_label'
      ? setAreas([...areas, { area_name: '', area_id: '' }])
      : setbins([...bins, { bin_number: '' }]);
    console.log('aaa');
  };

  const hanldedeletebinposition = (index) => {
    if (
      user?.role === 'prod_ebmr' &&
      searchParams.get('type') !== 'prod_label'
    ) {
      const list = [...areas];
      list.splice(index, 1);
      setAreas(list);
    } else {
      const list = [...bins];
      list.splice(index, 1);
      setbins(list);
    }
  };

  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        {searchParams.get('type') !== 'Equipment' && (
          <Card
            title={
              user?.role === 'prod_ebmr' &&
              searchParams.get('type') !== 'prod_label'
                ? 'Generate Area Labels'
                : 'Generate Bin QR Labels'
            }
            className={styles.CustomPanel}
          >
            {user?.role === 'prod_ebmr' &&
            searchParams.get('type') !== 'prod_label'
              ? areas?.map((area, index) => {
                  return (
                    <>
                      <Row gutter={24} key={index}>
                        <Col xs={10} xl={6} span={6}>
                          <FormItem
                            lable="Area name"
                            // name="bin_number"
                            rules={[
                              {
                                required: false,
                                message: 'Enter damaged containers'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter the Area Name"
                              onChange={(e) =>
                                hanldeAddbin(e, index, 'area_name')
                              }
                              value={area?.area_name}
                            />
                          </FormItem>
                        </Col>
                        <Col xs={10} xl={6} span={6}>
                          <FormItem
                            lable="Area id"
                            // name="bin_number"
                            rules={[
                              {
                                required: false,
                                message: 'Enter damaged containers'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter the Area ID"
                              onChange={(e) =>
                                hanldeAddbin(e, index, 'area_id')
                              }
                              value={area?.area_id}
                            />
                          </FormItem>
                        </Col>
                        {areas.length === index + 1 ? (
                          <Col xs={10} xl={6} span={6}>
                            <PlusCircleOutlined
                              onClick={() => hanldeAddbinposition()}
                            />
                          </Col>
                        ) : (
                          <Col xs={10} xl={6} span={6}>
                            <DeleteOutlined
                              onClick={() => hanldedeletebinposition(index)}
                            />
                          </Col>
                        )}
                      </Row>
                    </>
                  );
                })
              : bins?.map((bin, index) => {
                  return (
                    <>
                      <Row gutter={24} key={index}>
                        <Col xs={10} xl={6} span={6}>
                          <FormItem
                            lable="Enter the Bin Number"
                            // name="bin_number"
                            rules={[
                              {
                                required: false,
                                message: 'Enter damaged containers'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter the Bin Number"
                              onChange={(e) => hanldeAddbin(e, index)}
                              value={bin?.bin_number}
                            />
                          </FormItem>
                        </Col>
                        {console.log(bins?.length)}
                        {bins.length === index + 1 ? (
                          <Col xs={10} xl={6} span={6}>
                            <PlusCircleOutlined
                              onClick={() => hanldeAddbinposition()}
                            />
                          </Col>
                        ) : (
                          <Col xs={10} xl={6} span={6}>
                            <DeleteOutlined
                              onClick={() => hanldedeletebinposition(index)}
                            />
                          </Col>
                        )}
                      </Row>
                    </>
                  );
                })}
            <FormItem className="text-center">
              <Space>
                <CustomButton
                  type="primary"
                  ghost
                  onClick={() => history.back()}
                >
                  Cancel
                </CustomButton>
                <CustomButton type="primary" htmlType="submit">
                  Add
                </CustomButton>
              </Space>
            </FormItem>
          </Card>
        )}
        <Card
          title={
            <span>
              {searchParams.get('type') === 'Equipment'
                ? "Equipment ID's"
                : user?.role === 'prod_ebmr' &&
                  searchParams.get('type') !== 'prod_label'
                ? 'Area Names'
                : 'Bin Numbers'}
            </span>
          }
          extra={
            <Space>
              <Search
                onChange={(e) => handleChange(e)}
                className={`w-100 ${styles.searchbar}`}
                justify="start"
                align="start"
                placeholder={
                  searchParams.get('type') === 'Equipment'
                    ? 'Search by Equipment #'
                    : user?.role === 'prod_ebmr' &&
                      searchParams.get('type') !== 'prod_label'
                    ? 'Search by Area name'
                    : 'Search by Bin Number'
                }
              />
            </Space>
          }
          className={`${styles.cardStyles_approver}`}
        >
          <div className={`${styles.table_container}`}>
            <CustomTable
              className={styles.tableStyles}
              columns={
                user?.role === 'prod_ebmr' &&
                searchParams.get('type') !== 'Equipment' &&
                searchParams.get('type') !== 'prod_label'
                  ? Areacolumns
                  : columns
              }
              dataSource={
                searchParams.get('type') === 'Equipment'
                  ? equipmentsList
                  : user?.role === 'prod_ebmr' &&
                    searchParams.get('type') !== 'prod_label'
                  ? areaList
                  : binList
              }
              // className={styles.scrolling}
              rowKey={(record) => record.id}
              scroll={{ x: 'auto' }}
              locale={locale}
              pagination={{
                size: 'small',
                total: pagination?.total_records || 0,
                showSizeChanger: false,
                onChange: (page) => {
                  setPage(page);
                }
              }}
            />
          </div>
        </Card>
        <br />
        <FormItem className="text-center">
          <CustomButton
            className={styles.inwardButton}
            onClick={() => history.push('/landingpage')}
            type="primary"
          >
            Back to Home
          </CustomButton>
        </FormItem>
      </Form>
    </Layout>
  );
};
export default generateLable;
